// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function preferredGain_of_json_poly(x) {
  const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(x);
  if (tag === "album") {
    return "album";
  } else if (tag === "track") {
    return "track";
  } else {
    return;
  }
}

function preferredGain_of_json(x) {
  const x$1 = preferredGain_of_json_poly(x);
  if (x$1 !== undefined) {
    return x$1;
  } else {
    return Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  }
}

function preferredGain_to_json(x) {
  if (x === "album") {
    return "album";
  } else {
    return "track";
  }
}

function stringOfPreferredGain(param) {
  if (param === "album") {
    return "album";
  } else {
    return "track";
  }
}

function preferredGainOfString(param) {
  switch (param) {
    case "album" :
      return "album";
    case "track" :
      return "track";
    default:
      return;
  }
}

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.preAmp;
  const v$1 = x.preferredGain;
  return {
    preAmp: v !== undefined ? Ppx_deriving_json_runtime.Primitives.float_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"preAmp\""),
    preferredGain: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(preferredGain_of_json, v$1) : undefined
  };
}

function to_json(x) {
  return {
    preAmp: x.preAmp,
    preferredGain: Ppx_deriving_json_runtime.Primitives.option_to_json(preferredGain_to_json, x.preferredGain)
  };
}

const ReplayGainOptions = {
  preferredGain_of_json_poly: preferredGain_of_json_poly,
  preferredGain_of_json: preferredGain_of_json,
  preferredGain_to_json: preferredGain_to_json,
  stringOfPreferredGain: stringOfPreferredGain,
  preferredGainOfString: preferredGainOfString,
  of_json: of_json,
  to_json: to_json
};

export {
  ReplayGainOptions,
}
/* No side effect */
